import { isProduction } from './appEnvironment'

/**
 * Enhanced logging function that only outputs messages in development environments.
 *
 * This function wraps the standard console.log and only executes in non-production
 * environments, preventing debug logs from appearing in production. It passes through
 * all arguments to console.log, maintaining the same signature and functionality.
 *
 * Usage:
 *   import { log } from './log';
 *
 *   log('User logged in', userData);
 *   log('API response:', response);
 *
 * @param args - Any arguments that would normally be passed to console.log
 */

export const log = <T extends unknown[]>(...arguments_: T): void => {
  if (!isProduction()) {
    console.log(...arguments_)
  }
}

export const logError = <T extends unknown[]>(...arguments_: T): void => {
  if (!isProduction()) {
    console.error(...arguments_)
  }
}
